import React from 'react';
import ReactMarkdown from 'react-markdown';
import "./MarkdownRenderer.css";
// import remarkGfm from 'remark-gfm';
// import rehypeRaw from 'rehype-raw';
// import rehypeHighlight from 'rehype-highlight';

const preprocessMarkdown = (text) => {
  return (
    text
      .replace(/(?<!\n)\n(?!\n)/g, '  \n')
  );
};

export const MarkdownRenderer = ({ content }) => {
  const processed = preprocessMarkdown(content);

  return (
    <ReactMarkdown 
      children={processed} 
      // remarkPlugins={[remarkGfm]}
      // rehypePlugins={[rehypeRaw]}
      components={{
        a: ({ node, ...props }) => (
          <a {...props} target="_blank" rel="noopener noreferrer" />
        ),
      }}
    />
  );
};



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/MessageRenderer/MarkdownRender.jsx